import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Colors } from "../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import HamburgerButton from "./HamburgerButton.tsx";

interface HeaderWithBackButtonProps {
  title?: string;
}

export default function HeaderWithBackButton({title}: HeaderWithBackButtonProps) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        marginTop: 2,
        marginBottom: 6,
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          color: Colors.primaryTextColor,
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>

      <Typography
        variant="bodyMedium"
        className="body-medium"
        textAlign="center"
      >
        {title}
      </Typography>

      <HamburgerButton />
    </Box>
  );
}
